var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SearchInput',{attrs:{"value":_vm.state,"placeholder":'placeholder'}})
}
var staticRenderFns = []

export { render, staticRenderFns }